var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnedrive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8716 6.58396L10.8716 6.58396C13.5205 5.90458 16.2169 7.42347 17.0317 9.9991L13.8541 13.0379L13.1993 12.4993C12.6006 12.0069 11.8015 11.3504 11.0007 10.6939C10.1999 10.0375 9.3968 9.3807 8.79004 8.88788C8.53089 8.6774 8.30682 8.49622 8.13376 8.35756C8.82624 7.48731 9.78622 6.8623 10.8716 6.58396Z",
    fill: "#0364B8",
    stroke: "#0364B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86533 9.12364L9.86519 9.12427C9.15504 8.68451 8.33609 8.45205 7.50081 8.45313C7.48154 8.45313 7.46255 8.45432 7.44328 8.45454C4.95879 8.48534 2.96962 10.5244 3.00035 13.009C3.01151 13.9102 3.29311 14.7873 3.80864 15.5266L9.37619 14.8293L13.6447 11.3874L9.86533 9.12364Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5891 10.1498C17.507 10.144 17.4247 10.141 17.3423 10.1406C16.8438 10.1401 16.3504 10.242 15.8928 10.4398L15.8927 10.4395L13.6406 11.3871L16.1234 14.4539L20.5618 15.5329C21.5197 13.7547 20.8546 11.5368 19.0765 10.5789C18.617 10.3314 18.1098 10.1851 17.5891 10.1498Z",
    fill: "#1490DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8125 15.5299C4.22668 16.1254 4.77882 16.6117 5.42178 16.9475C6.06473 17.2833 6.7794 17.4585 7.50475 17.4581H17.3503C18.0104 17.4582 18.6583 17.2797 19.2251 16.9414C19.7919 16.603 20.2566 16.1176 20.5698 15.5365L13.6486 11.3906L3.8125 15.5299Z",
    fill: "#28A8EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedrive);
export default __webpack_public_path__ + "static/media/onedrive.f5d7dd77ec36d874dd8921bf77bde382.svg";
export { ForwardRef as ReactComponent };